const ACTIONS = {
    SET_DATA: 1
}

/**
 * 
 * @param {GlobalAdDomainData} initialState 
 * @param {Object} action 
 * @param {number} action.type
 * @param {GlobalAdDomainData} action.data
 */
export default function globalAdDomainDataReducer(initialState = {}, action) {
    let {type, data} = action
    switch(type) {
        case ACTIONS.SET_DATA:
            return {...initialState, ...data};
        default:
            return initialState;
    }
}

/**
 * 
 * @param {GlobalAdDomainData} data 
 */

export function setAdDomainData(data) {
    return { type: ACTIONS.SET_DATA, data }
}